import React, { createContext, useContext, useState, useEffect } from 'react';  
import axios from 'axios';  
import { useTelegram } from './TelegramProvider';  
  
const AuthContext = createContext();
  
export const AuthProvider = ({ children }) => {  
  const { userData, authData } = useTelegram();  
  const [isAuthenticated, setIsAuthenticated] = useState(false);  
  const [jwt, setJwt] = useState(null);  
  const [playerProfile, setPlayerProfile] = useState(null);  
  const [loading, setLoading] = useState(true);  
  
  const api = axios.create({  
    baseURL: 'https://authentication.zkcandyapi.com',
    headers: {  
    'Content-Type': 'application/json'  
  }   
  });  
  
  api.interceptors.request.use((config) => {  
    if (jwt) {  
      config.headers.Authorization = `Bearer ${jwt}`;  
    }  
    return config;  
  });

  const authenticateUser = async () => {      
    try {      
      if (!userData || !authData) {      
        throw new Error('No Telegram auth data available');      
      }  

      // // Get launch params  
      // const launchParams = window.Telegram?.WebApp?.retrieveLaunchParams() || {};  
      // console.log('Launch Params:', launchParams);      
      
      // Properly structure the auth data for verification  
      const telegramAuthData = {  
        ...authData,  
        hash: authData.hash  
      };  
  
      const response = await api.post('/', {      
        action: 'tgauth',      
        telegramAuthData,
        flag: 'game center',
        gameId: '6191aac0-6c1f-4b4c-bf0c-88bb8e28fa99',
        apiKey: '1dab8291096c634389a54b44b133ce19a464471c6b9643ef58b0de69dcb385e3'
      });    
      
      console.log('response: ' + JSON.stringify(response.data))    
      
      const { token, profile } = response.data.data;    
      setJwt(token);    
      setPlayerProfile(profile);    
      setIsAuthenticated(true);    
          
      localStorage.setItem('jwt', token);    
      localStorage.setItem('playerProfile', JSON.stringify(profile));    
    } catch (error) {      
      console.error('Authentication error:', error);      
      setIsAuthenticated(false);      
      setJwt(null);      
      setPlayerProfile(null);      
    } finally {      
      setLoading(false);      
    }      
};    
  
  
  useEffect(() => {    
    const initAuth = async () => {  
      if (userData && authData) {    
        await authenticateUser();    
      }  
    };  
    
    initAuth();  
  }, [userData, authData]); // Add both dependencies ;  
  
  const logout = () => {  
      setJwt(null);  
      setPlayerProfile(null);  
      setIsAuthenticated(false);  
      localStorage.removeItem('jwt');  
      localStorage.removeItem('playerProfile');  
  }; 
  
  return (  
    <AuthContext.Provider  
      value={{  
        isAuthenticated,
        setIsAuthenticated,  
        jwt,  
        playerProfile,  
        loading,
        setLoading,  
        api,  
        logout,  
        authenticateUser  
      }}  
    >  
      {children}  
    </AuthContext.Provider>  
  );  
};  
  
export const useAuth = () => {  
  const context = useContext(AuthContext);  
  if (!context) {  
    throw new Error('useAuth must be used within an AuthProvider');  
  }  
  return context;  
};  
